// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ResourceCitizenship extends TrackingModel {
	public ResourceCitizenshipId: number = 0;
	public ResourceId: number = 0;
	public CitizenshipId: number = 0;
}